export enum TourSoundGenreEnum {
  GOOGLE_CLOUD_TEXT_TO_SPEECH = 'GOOGLE_CLOUD_TEXT_TO_SPEECH',
  MP3_FILE = 'MP3_FILE',
}
